module.exports = __webpack_public_path__ + "static/media/rest-api.e82ea9c4.svg";